export {};

if (process.env.REACT_SCAN_ENABLED === 'true') {
  const { scan } = await import('react-scan'); // import this BEFORE react
  const react = await import('react');

  if (typeof window !== 'undefined') {
    scan({
      animationSpeed: 'slow',
      enabled: true,
      // log: true, // logs render info to console (default: false)
      trackUnnecessaryRenders: true,
    });
  }
}
